/*!
 * @oppo/lib-heytap-jsapi.js v1.0.1
 * (c) 2018-2019 liutianwen@oppo.com
 * native通信方法.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.HeytapJsApi = factory());
}(this, function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var SDK_VERSION = '1.0.0';

  function noop() {}

  var WebviewJSAPI =
  /*#__PURE__*/
  function () {
    function WebviewJSAPI() {
      _classCallCheck(this, WebviewJSAPI);

      this.clientCallMap = {};
      this.apiCallMap = {};
      this.broadMap = {};
      window.heytapCall = this._clientCallHandler.bind(this);
    }

    _createClass(WebviewJSAPI, [{
      key: "invoke",
      value: function invoke() {
        var _this = this;

        var callData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callId = getRandomCode();
        var methodName = callData.name;

        if (!methodName) {
          throw new Error('The name field is required');
        }

        if (methodName.split(/\./).length === 1) {
          if (!callData.module) {
            throw new Error('The module field is required when there is no module information in the name field');
          }

          methodName = "".concat(callData.module, ".").concat(methodName);
        }

        if (!callData.fail || !isFunction(callData.fail)) {
          callData.fail = noop;
        }

        if (!callData.success || !isFunction(callData.success)) {
          callData.success = noop;
        }

        if (callData.complete && isFunction(callData.complete)) {
          this.apiCallMap[callId] = callData.complete;
          var callResult = window.HeytapNativeApi ? HeytapNativeApi.invoke(methodName, JSON.stringify(callData.data), callId) : false;

          if (!callResult) {
            callData.fail('unsupported method');
          } else {
            callData.success();
          }
        } else {
          return new Promise(function (resolve, reject) {
            _this.apiCallMap[callId] = function (result) {
              resolve(result);
            };

            var callResult = window.HeytapNativeApi ? HeytapNativeApi.invoke(methodName, JSON.stringify(callData.data), callId) : false;

            if (!callResult) {
              reject('unsupported method');
            } else {
              callData.success();
            }
          });
        }
      }
      /**
       * 给客户端调用的，用于调用API后客户端通知API的回调
       * @param {*} callId 
       * @param {*} params 
       */

    }, {
      key: "callback",
      value: function callback(callId, params) {
        this.apiCallMap[callId] && this.apiCallMap[callId](params);
        delete this.apiCallMap[callId];
      }
    }, {
      key: "_clientCallHandler",
      value: function _clientCallHandler(action) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!action || !this.clientCallMap[action]) {
          return;
        }

        var actionList = this.clientCallMap[action];
        actionList.forEach(function (action) {
          action(params);
        });
      }
      /**
       * 注册客户端回调H5的行为
       * @param {*} actionName 
       * @param {*} actionCallback 
       */

    }, {
      key: "registeAction",
      value: function registeAction() {
        var actionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var actionCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        if (!actionName) {
          throw new Error('注册事件回调的动作名不能为空');
        }

        if (!actionCallback || !isFunction(actionCallback)) {
          throw new Error('注册事件回调的函数不能为空');
        }

        var tmpCallback = this.clientCallMap[actionName];

        if (tmpCallback) {
          this.clientCallMap[actionName].push(actionCallback);
        } else {
          this.clientCallMap[actionName] = [actionCallback];
        }
      }
      /**
       * 注册一个广播事件
       * @param {String} broadcast   广播名称
       * @param {Function} callback    回调函数
       */

    }, {
      key: "registerBroadcast",
      value: function registerBroadcast(broadcast) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        if (!broadcast) {
          return;
        }

        this.broadMap[broadcast] = callback; // 向webview注册一个广播事件

        window.HeytapNativeApi && HeytapNativeApi.registerBroadcastReceiver(broadcast, broadcast);
      }
      /**
       * 删除一个广播事件
       * @param {String|Array} broadcast   要删除的广播名称，可以是数组
       */

    }, {
      key: "removeBroadcast",
      value: function removeBroadcast(broadcast) {
        var _this2 = this;

        if (!broadcast) {
          return;
        }

        if (typeof broadcast === 'string') {
          broadcast = [broadcast];
        }

        if (broadcast instanceof Array) {
          broadcast.forEach(function (name) {
            window.HeytapNativeApi && HeytapNativeApi.removeBroadcastReceiver(name);
            delete _this2.broadMap[name];
          });
        }
      }
      /**
       * 给客户端调用的方法，用于触发广播的事件回调
       * @param {String} broadcast   广播名称
       * @param {Object} args        本次广播传递的参数
       */

    }, {
      key: "broadcastReceiver",
      value: function broadcastReceiver(broadcast, args) {
        var callback = this.broadMap[broadcast];
        callback && callback(JSON.parse(args));
      }
      /**
       * 前端webview内触发一次广播，调用该方法后，客户端会调用broadcastReceiver方法，以触发注册的广播回调
       * @param {String} broadcast   要触发的广播名称
       * @param {Object} args             传递的参数
       */

    }, {
      key: "doBroadcast",
      value: function doBroadcast(broadcast, args) {
        if (!broadcast || !this.broadMap[broadcast]) {
          return;
        }

        window.HeytapNativeApi && window.HeytapNativeApi.broadcast(broadcast, JSON.stringify(args));
      }
    }, {
      key: "version",
      get: function get() {
        return SDK_VERSION;
      }
    }]);

    return WebviewJSAPI;
  }();

  function isFunction(func) {
    return typeof func === 'function';
  }

  function getRandomCode() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
    return Math.random().toString().slice(-len);
  }

  var HeytapJsApi = new WebviewJSAPI();

  return HeytapJsApi;

}));
//# sourceMappingURL=heytapJsApi.js.map
